import { ORDER } from '@hive/status'
/*
  Order statuses
*/

export const ORDER_STATUS_REFUNDED = -2
export const ORDER_STATUS_CANCELED = -1
export const ORDER_STATUS_INITIAL = 0
export const ORDER_STATUS_PLACED = 1
export const ORDER_STATUS_PAID = 2
export const ORDER_STATUS_WAITING_CONFIRMATION = 3
export const ORDER_STATUS_WAITING_FOR_PAYMENT = 10
export const ORDER_STATUS_ASSEMBLY_IN_PROGRESS = 5
export const ORDER_STATUS_ASSEMBLY_COMPLETE = 6
export const ORDER_STATUS_ACCEPTED_BY_COURIER = 4
export const ORDER_STATUS_WAITING_FOR_COURIER = 7
export const ORDER_STATUS_DEVIVERY_IN_PROGRESS = 8
export const ORDER_STATUS_WAITING_FOR_POST_PAYMENT = 11
export const ORDER_STATUS_POST_PAYMENT_PAID = 12

export const ORDER_STATUS_DELIVERED = 9
export const ORDER_STATUS_COMPLETED = 99

export const ORDER_STATUS_RECALL_CLIENT = 20
export const ORDER_STATUS_WAITING_FOR_SLOT_CHANGE = 21
export const ORDER_SLOT_CHANGED = 22

export const ORDER_STATUS_WAITING_FOR_CUSTOMER = 30

export const ASSEMBLABLE_STATUSES = [
  ORDER_STATUS_CANCELED,
  ORDER_STATUS_INITIAL,
  ORDER_STATUS_PLACED,
  ORDER_STATUS_PAID,
  ORDER_STATUS_WAITING_FOR_PAYMENT,
  ORDER_STATUS_ASSEMBLY_IN_PROGRESS,
  ORDER_STATUS_ASSEMBLY_COMPLETE
]

export const COURIER_STATUSES = [
  ORDER_STATUS_ACCEPTED_BY_COURIER,
  ORDER_STATUS_WAITING_FOR_COURIER,
  ORDER_STATUS_DEVIVERY_IN_PROGRESS,
  ORDER_STATUS_WAITING_FOR_POST_PAYMENT,
  ORDER_STATUS_POST_PAYMENT_PAID
]

export const FINISHED_STATUSES = [
  ORDER.ACCEPTED_BY_COURIER,
  ORDER.WAITING_FOR_COURIER,
  ORDER.DELIVERY_IN_PROGRESS,
  ORDER.DELIVERED,
  ORDER.COMPLETED,
  ORDER.WAITING_FOR_PICKUP
]

export const COMPLETED_STATUSES = [
  ORDER_STATUS_DELIVERED,
  ORDER_STATUS_COMPLETED
]